"use es6";

import { optimizedAppearDataAttribute } from "./data-id";
function getOptimisedAppearId(visualElement) {
  return visualElement.getProps()[optimizedAppearDataAttribute];
}
export { getOptimisedAppearId };